import React, {createContext, useReducer, useMemo} from "react";

let AdministracionContext = createContext();

let initialState = {
  claves:{
    listado: []
  },
  plantillas:{
    listado:[]
  },
  reglas:{
    listado:[]
  },
  empresas:{
    listado:[]
  }
};

let reducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return initialState;
    case "apiKeyListado":
      return { ...state, claves: {...state.claves, listado: action.listado} };
    case "reglasListado":
      return { ...state, reglas: {...state.reglas, listado: action.listado} };
    case "empresasListado":
      return { ...state, empresas: {...state.empresas, listado: action.listado} };
    case "plantillasListado":
      return { ...state, plantillas: {...state.plantillas, listado: action.listado} };
    default:
      return state;
  }
};

function AdministracionProvider(props) {
  let [state, dispatch] = useReducer(reducer, initialState);
  let value = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <AdministracionContext.Provider value={value}>{props.children}</AdministracionContext.Provider>
  );
}

let AdministracionConsumer = AdministracionContext.Consumer;

export { AdministracionContext, AdministracionProvider, AdministracionConsumer };